const styleSheet = () => ({
  svgContainer: {
    marginTop: '-23.5px',
    marginLeft: '143px',
    marginRight: '144px',
  },
  titleContainer: {
    marginTop: '11px',
    marginLeft: '27px',
  },
  title: {
    height: '30px',
    width: '436px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '20px',
    fontWeight: 700,
    letterSpacing: 0,
    lineHeight: '30px',
    textAlign: 'center',
  },
  descriptionContainer: {
    marginTop: '32px',
    marginLeft: '54px',
  },
  description: {
    display: 'block',
    textAlign: 'left',
    height: '42px',
    width: '416px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 300,
    letterSpacing: 0,
    lineHeight: '21px',
    marginLeft: '-73px',
    marginRight: '-73px',
  },
  buttonContainer: {
    marginTop: '26px',
    marginLeft: '321px',
  },
});

export default styleSheet;
